import React from 'react';
import { useMedia } from 'react-use';
import { mobileMediaQuery } from 'constants/mediaQuery';
import { ExternalAcceptPartnershipFlowState } from 'constants/ui';
import AcceptPartnershipIllustrationBase from '../AcceptPartnershipIllustrationBase';
const RegisterIllustrationSvg = () => {
    const isMobile = useMedia(mobileMediaQuery);
    if (isMobile) {
        return null;
    }
    return React.createElement(AcceptPartnershipIllustrationBase, { acceptPartnershipState: ExternalAcceptPartnershipFlowState.INITIAL });
};
export default RegisterIllustrationSvg;
